import { Badge } from 'react-bootstrap';

function StatusBadge({ status }) {
  let variant = 'secondary';
  if (status === 'Open') {
    variant = 'warning';
  } else if (status === 'Released') {
    variant = 'success';
  }

  if (status === 'Pending_x0020_Approval') {
    status = 'Pending';
  }
  return (
    <div>
      <Badge variant={variant}>{status}</Badge>
    </div>
  );
}

export default StatusBadge;
